import React from 'react';
import { motion } from 'framer-motion';
import { Upload, Sparkles, Video } from 'lucide-react';

const stepsAgents = [
  {
    id: 1,
    title: 'Envoyez votre lien Matterport',
    description: '+ Vos clips de drone si vous en avez',
    icon: Upload,
  },
  {
    id: 2,
    title: "On s'en occupe",
    description: "On crée votre vidéo, livrée le lendemain (du lundi au jeudi)",
    icon: Sparkles,
  },
  {
    id: 3,
    title: 'Recevez votre vidéo',
    description: 'Prête à publier sur vos annonces et réseaux',
    icon: Video,
  },
];

const stepsPartenaires = [
  {
    id: 1,
    title: 'Envoyez votre lien Matterport',
    description: '+ Vos clips de drone si vous en avez',
    icon: Upload,
  },
  {
    id: 2,
    title: "On s'en occupe",
    description: "On crée votre vidéo, livrée le lendemain (du lundi au jeudi)",
    icon: Sparkles,
  },
  {
    id: 3,
    title: 'Recevez votre vidéo',
    description: 'Prête à publier sur les portails et réseaux de vos clients',
    icon: Video,
  },
];

type ProcessFRProps = {
  variant?: 'agents' | 'partenaires';
};

const ProcessFR: React.FC<ProcessFRProps> = ({ variant = 'partenaires' }) => {
  const steps = variant === 'agents' ? stepsAgents : stepsPartenaires;

  return (
    <section className="py-16 sm:py-20 bg-slate-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <motion.h2
            className="font-manrope text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            Comment ça marche
          </motion.h2>
        </div>
        <div className="max-w-5xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10">
            {steps.map((step, index) => (
              <motion.div
                key={step.id}
                className="text-center"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
              >
                <div className="w-16 h-16 sm:w-20 sm:h-20 mx-auto mb-5 rounded-xl bg-slate-100 border border-slate-200 flex items-center justify-center">
                  <step.icon className="w-7 h-7 sm:w-8 sm:h-8 text-gray-700" strokeWidth={1.5} />
                </div>
                <p className="font-manrope text-sm font-medium text-[#3C59B2] mb-2">
                  Étape {step.id}
                </p>
                <h3 className="font-manrope text-lg sm:text-xl font-bold text-gray-900 mb-3">
                  {step.title}
                </h3>
                <p className="text-gray-600 text-sm sm:text-base leading-relaxed max-w-sm mx-auto">
                  {step.description}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProcessFR;
